import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '@/api/axios';
import { API } from '@/api/endpoints';
import { STALE_TIME } from '@/api/staleTimes';
import {
  limitTypeListSchema,
  type LimitType,
  type UpdateLimitTypePayload,
} from '../types/limitType.types';

export const limitTypeQueryKeys = {
  all: () => ['limit-types'] as const,
  list: () => [...limitTypeQueryKeys.all(), 'list'] as const,
};

export const limitTypesQueryOptions = () =>
  queryOptions({
    queryKey: limitTypeQueryKeys.list(),
    queryFn: async (): Promise<LimitType[]> => {
      const res = await apiClient.get(API.limitType.list);
      return limitTypeListSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });

export async function updateLimitType(id: number, payload: UpdateLimitTypePayload): Promise<void> {
  await apiClient.patch(API.limitType.update(id), payload);
}
